import { useCallback, useEffect, useState, } from "react";
import useCallbackRef from "./useCallbackRef";
import usePrevious from "./usePrevious";
const noop = () => {
    // empty
};
export default function useControllableState({ prop, defaultProp, onChange = noop, }) {
    const [state, setState] = useState(defaultProp);
    const handleChange = useCallbackRef(onChange);
    const prevState = usePrevious(state);
    useEffect(() => {
        if (prevState !== state) {
            handleChange(state);
        }
    }, [state, prevState, handleChange]);
    const isControlled = prop !== undefined;
    const value = isControlled ? prop : state;
    const setValue = useCallback((nextValue) => {
        if (isControlled) {
            const controlledValue = typeof nextValue === "function"
                ? nextValue(prop)
                : nextValue;
            if (controlledValue !== prop)
                handleChange(controlledValue);
        }
        else {
            setState(nextValue);
        }
    }, [isControlled, prop, setState, handleChange]);
    return [value, setValue];
}
